import React from 'react'
import { Link } from 'react-router-dom'
import { DocumentCardProps } from '@/types/document'
import { Clock, Tag, User, BookOpen } from 'lucide-react'

export const DocumentCard: React.FC<DocumentCardProps> = ({ document }) => {
  const getDifficultyColor = (difficulty?: string) => {
    switch (difficulty) {
      case 'beginner':
        return 'bg-green-100 dark:bg-green-900/20 text-green-800 dark:text-green-200'
      case 'intermediate':
        return 'bg-yellow-100 dark:bg-yellow-900/20 text-yellow-800 dark:text-yellow-200'
      case 'advanced':
        return 'bg-red-100 dark:bg-red-900/20 text-red-800 dark:text-red-200'
      default:
        return 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200'
    }
  }

  const getDifficultyText = (difficulty?: string) => {
    switch (difficulty) {
      case 'beginner':
        return '初级'
      case 'intermediate':
        return '中级'
      case 'advanced':
        return '高级'
      default:
        return '通用'
    }
  }

  return (
    <Link 
      to={`/document/${document.id}`}
      className="block bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-lg hover:border-gray-300 dark:hover:border-gray-600 transition-all duration-200 group"
    >
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 mb-2 line-clamp-2">
              {document.title}
            </h3>
            <span className="inline-block px-2 py-1 text-xs font-medium bg-primary-100 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300 rounded-full">
              {document.category}
            </span>
          </div>
          {/* {document.difficulty && (
            <span className={`inline-block px-2 py-1 text-xs font-medium rounded-full ${getDifficultyColor(document.difficulty)}`}>
              {getDifficultyText(document.difficulty)}
            </span>
          )} */}
        </div>

        <p className="text-gray-600 dark:text-gray-400 text-sm mb-4 line-clamp-3">
          {document.description}
        </p>

        {/* <div className="flex flex-wrap gap-1 mb-4">
          {document.tags.slice(0, 3).map((tag, index) => (
            <span 
              key={index}
              className="inline-flex items-center gap-1 px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded-md"
            >
              <Tag size={10} />
              {tag}
            </span>
          ))}
          {document.tags.length > 3 && (
            <span className="inline-block px-2 py-1 text-xs text-gray-500">
              +{document.tags.length - 3} 更多
            </span>
          )}
        </div> */}

        {/* <div className="flex items-center justify-between text-xs text-gray-500 pt-4 border-t border-gray-100">
          <div className="flex items-center gap-4">
            {document.author && (
              <div className="flex items-center gap-1">
                <User size={12} />
                <span>{document.author}</span>
              </div>
            )}
            {document.readTime && (
              <div className="flex items-center gap-1">
                <Clock size={12} />
                <span>{document.readTime}</span>
              </div>
            )}
          </div>
          <div className="flex items-center gap-1">
            <BookOpen size={12} />
            <span className="text-primary-600 font-medium">阅读文档</span>
          </div> */}
        {/* </div> */}
      </div>
    </Link>
  )
}
